module.exports = __webpack_public_path__ + "static/media/ALEXANDER MATERIAN - TRABAJO DE GRADO DISEÑO DE MODA 1.bf0c3de4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/ALEXANDER MATERIAN - TRABAJO DE GRADO DISEÑO DE MODA 1.jpg
// module id = 785
// module chunks = 0